module.exports = __webpack_public_path__ + "img/462-4abba7.png";